/*
	Name:         cardTemplate.js
	Description:  cardTemplate script for the theme.
	Version:      1.0.0
	Author:       GH Advertising
*/

(function (window) {
    const blogPostClass = "m-card";
    const id = Math.floor(Math.random() * 10000000);

    class BlogPost {
        constructor(data) {
            this._data = data;
            this._prefix = blogPostClass;
        }

        render() {
            return `<article class="${this._prefix} ${this._prefix}--post">
                <a href="${this._data.link}" target="_self" aria-labelledby="${id}">
                  ${this._renderImage()}
                    <div class="${this._prefix}__content">
                        ${this._renderTerms()}
                        ${this._renderTitle()}
                        ${this._renderCTA()}
                    </div>
                </a>
            </article>`;
        }

        _renderImage() {
            const img = this._data.image_with_fallback;

            return img ? `<div class="${this._prefix}__image"><img width="352" height="487" src="${img}"/></div>` : null;
        }

        _renderTitle() {
            const title = this._data.title?.rendered || "";
            return `<h2 id="${id}" class="${this._prefix}__headline text-big">${title}</h2>`;
        }

        _renderTerms() {
            const embedded = this._data && this._data._embedded ? this._data._embedded["wp:term"] : null;

            if (!embedded || !embedded.length) {
                return "";
            }

            const names = [];
            embedded.forEach((group) => {
                if (!Array.isArray(group)) {
                    return;
                }

                group.forEach((term) => {
                    if (term && term.taxonomy === "category" && term.name) {
                        names.push(term.name);
                    }
                });
            });

            if (!names.length) {
                return "";
            }

            return `<p class="${this._prefix}__meta text-manrope">${names.join(", ")}</p>`;
        }

        _renderCTA() {
            return `<div class="${this._prefix}__read-more"><span class="text-link-icon-right">Read More</span></div>`;
        }
    }

    window.BlogPost = BlogPost;
})(window);
